module.exports = __webpack_public_path__ + "img/nettanleggplus.80283dae.jpg";